import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Toast, ToastContainer } from 'react-bootstrap';
import { algerianStates, sizeOptions, colorOptions, validateAlgerianPhone, createOrderWhatsappUrl, createOrderMessengerUrl } from '../data/orderFormData';
import './OrderForm.css';

const OrderForm = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    state: '',
    municipality: '',
    size: '',
    color: '',
    notes: ''
  });

  const [errors, setErrors] = useState({});
  const [showToast, setShowToast] = useState(false);

  // تحديث البيانات عند تغيير الحقول
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // إزالة الخطأ عند التعديل
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  // التحقق من صحة البيانات
  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'الاسم الكامل مطلوب';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'رقم الهاتف مطلوب';
    } else if (!validateAlgerianPhone(formData.phone)) {
      newErrors.phone = 'رقم الهاتف غير صحيح. استخدم رقم جزائري صالح';
    }

    if (!formData.state) {
      newErrors.state = 'الولاية مطلوبة';
    }

    if (!formData.municipality.trim()) {
      newErrors.municipality = 'البلدية مطلوبة';
    }

    if (!formData.size) {
      newErrors.size = 'المقاس مطلوب';
    }

    if (!formData.color) {
      newErrors.color = 'اللون مطلوب';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // إرسال الطلب عبر واتساب
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const whatsappUrl = createOrderWhatsappUrl(formData);
      setShowToast(true);

      // فتح واتساب بعد ثانيتين
      setTimeout(() => {
        window.open(whatsappUrl, '_blank');
      }, 2000);
    }
  };

  // تجهيز رسالة ماسنجر (مع بيانات المنتج)
  const messengerUrl = createOrderMessengerUrl({ ...formData, product: 'ملابس حسب الطلب' });

  return (
    <div className="order-form-page" dir="rtl">
      <Container className="order-container">
        {/* Header */}


        {/* Form Title */}
        <div className="form-title-section">
          <h1 className="main-title">اطلب ملابس خاصة بك</h1>
          <p className="subtitle">املأ النموذج أدناه لتقديم طلبك.</p>
        </div>

        {/* Order Form */}
        <Form onSubmit={handleSubmit} className="order-form">
          <Row>
            {/* الاسم الكامل */}
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label className="form-label">الاسم الكامل</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="مثال: فاطمة الزهراء"
                  value={formData.fullName}
                  onChange={(e) => handleInputChange('fullName', e.target.value)}
                  className={`form-control-custom ${errors.fullName ? 'is-invalid' : ''}`}
                />
                {errors.fullName && <div className="error-message">{errors.fullName}</div>}
              </Form.Group>
            </Col>

            {/* رقم الهاتف */}
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label className="form-label">رقم الهاتف</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="مثال: 0550 XXXXXX"
                  value={formData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  className={`form-control-custom ${errors.phone ? 'is-invalid' : ''}`}
                />
                {errors.phone && <div className="error-message">{errors.phone}</div>}
              </Form.Group>
            </Col>

            {/* الولاية والبلدية */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="form-label">الولاية</Form.Label>
                <Form.Select
                  value={formData.state}
                  onChange={(e) => handleInputChange('state', e.target.value)}
                  className={`form-select-custom ${errors.state ? 'is-invalid' : ''}`}
                >
                  <option value="">اختر ولايتك</option>
                  {algerianStates.map((state, index) => (
                    <option key={index} value={state}>{state}</option>
                  ))}
                </Form.Select>
                {errors.state && <div className="error-message">{errors.state}</div>}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="form-label">البلدية / الدائرة</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="مثال: باب الزوار"
                  value={formData.municipality}
                  onChange={(e) => handleInputChange('municipality', e.target.value)}
                  className={`form-control-custom ${errors.municipality ? 'is-invalid' : ''}`}
                />
                {errors.municipality && <div className="error-message">{errors.municipality}</div>}
              </Form.Group>
            </Col>

            {/* المقاس واللون */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="form-label">المقاس</Form.Label>
                <Form.Select
                  value={formData.size}
                  onChange={(e) => handleInputChange('size', e.target.value)}
                  className={`form-select-custom ${errors.size ? 'is-invalid' : ''}`}
                >
                  <option value="">اختر المقاس</option>
                  {sizeOptions.map((size, index) => (
                    <option key={index} value={size.value}>{size.label}</option>
                  ))}
                </Form.Select>
                {errors.size && <div className="error-message">{errors.size}</div>}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="form-label">اللون</Form.Label>
                <Form.Select
                  value={formData.color}
                  onChange={(e) => handleInputChange('color', e.target.value)}
                  className={`form-select-custom ${errors.color ? 'is-invalid' : ''}`}
                >
                  <option value="">اختر اللون</option>
                  {colorOptions.map((color, index) => (
                    <option key={index} value={color.value}>{color.label}</option>
                  ))}
                </Form.Select>
                {errors.color && <div className="error-message">{errors.color}</div>}
              </Form.Group>
            </Col>

            {/* الملاحظات */}
            <Col md={12}>
              <Form.Group className="mb-4">
                <Form.Label className="form-label">ملاحظة (اختياري)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="أضف أي تعليمات خاصة هنا ...."
                  value={formData.notes}
                  onChange={(e) => handleInputChange('notes', e.target.value)}
                  className="form-control-custom"
                />
              </Form.Group>
            </Col>

            {/* زر الإرسال */}
            <Col md={12}>
              <div className="d-flex flex-column flex-md-row gap-2 align-items-stretch w-100">
                <Button
                  type="submit"
                  className="submit-button px-4 py-2 flex-fill"
                  style={{ minWidth: 0, width: '100%' }}
                >
                  إرسال الطلب عبر الواتساب
                </Button>
                <Button
                  as="a"
                  href={messengerUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ backgroundColor: '#2F3E46', border: 'none', borderRadius: '8px', color: '#fff', padding: '10px 14px', minWidth: 0, width: '100%' }}
                  aria-label="إرسال عبر ماسنجر"
                  className="submit-button px-4 py-2 flex-fill mt-2 mt-md-0"
                  onClick={e => { if (!validateForm()) e.preventDefault(); }}
                  onMouseOver={e => e.currentTarget.style.opacity = 0.9}
                  onMouseOut={e => e.currentTarget.style.opacity = 1}
                >
                  <i className="bi bi-messenger me-2" aria-hidden="true"></i>
                  إرسال عبر ماسنجر
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Container>

      {/* Toast للتأكيد */}
      <ToastContainer position="top-center" className="toast-container">
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          className="success-toast"
          delay={5000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">تأكيد الطلب</strong>
          </Toast.Header>
          <Toast.Body>
            سيتم تحويلك إلى واتساب لإكمال الطلب
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default OrderForm;
